import React, { useState, useEffect, Fragment } from 'react'
import axios from 'axios'
import {Table,Row,Col,Label, Media, Badge, Input,InputGroup,InputGroupAddon,Button} from 'reactstrap'
import {Link}  from 'react-router-dom'
import {Actions, Delete, DonwloadCSVTemplate, UserImage, 
  UserName, Username, UserPermissions, User, ChooseAdminCSV, 
  AdministratorsBulkUpload, GuestEmail, AddGuest, 
  AddGuestIndividually, GuestBulkUpload, ChooseGuestCSV, 
  SendRegistrationReminder, SearchGuestEmail, Search, 
  Registered, GuestsList, BlockUser} from "../../../../constant"

import {UserThumbnail} from '../../../general/UserThumbnail'

const GuestsListTable = (props) =>  {

  const [guests , setGuest] = useState(props.guestsList)  

  axios.defaults.baseURL = `http://localhost:4000`
  const [guestUsers , setGuestUsers] = useState([])
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    guests.forEach(guestID => {
      axios.get(`/users/${guestID}`)
      .then(res => {
        setGuestUsers(guestUsers => [...guestUsers,res.data])
        console.log('Setting Guest User: ',res.data)
      }).catch(err => console.error("02",err))
    })
    setLoading(false)
  },[guests])
    
  if (isLoading) {
    return <div className="App">Loading...</div>;
  }
  return (
    <Fragment>
        <Row>
            <Col lg="4">
              <Label><b>{AddGuestIndividually}</b></Label>
              <InputGroup>
                <Input className="form-control" type="text" placeholder={GuestEmail} aria-label={GuestEmail}/>
                <InputGroupAddon addonType="append"><Button color="primary" className="mr-1" >{AddGuest}</Button></InputGroupAddon>
              </InputGroup>
            </Col>
            <Col lg="4">
              <Label><b>{SearchGuestEmail}</b></Label>
              <InputGroup>
                <Input className="form-control" type="text" placeholder={SearchGuestEmail} aria-label={GuestEmail}/>
                <InputGroupAddon addonType="append"><Button color="secondary" className="mr-1" >{Search}</Button></InputGroupAddon>
              </InputGroup>
            </Col>
            <Col lg="4">
                <Label>
                    <b>{GuestBulkUpload}</b> &nbsp;
                    <small>
                        <Link to={`${process.env.PUBLIC_URL}/Pages/Experiences/ExperiencesListView/ExperiencesListView`}> 
                        {DonwloadCSVTemplate}
                        </Link>
                    </small>
                </Label>
                <div className="custom-file">
                  <Input className="custom-file-input" id="validatedCustomFile" type="file" required="" />
                  <Label className="custom-file-label" htmlFor="validatedCustomFile">{ChooseGuestCSV}</Label>
                  <div className="invalid-feedback">{"Example invalid custom file feedback"}</div>
                </div>
            </Col>
            <Col lg="12">
                <Button color="warning" className="mr-1 f-right m-t-10" >{SendRegistrationReminder}</Button>
            </Col>
        </Row>
        
        <div className="table-responsive m-t-20">
            <Table hover>
                <thead>
                    <tr>
                        <th scope="col">{"#"}</th>
                        <th scope="col">{User}</th>
                          <th scope="col">{Registered}</th>
                        <th scope="col">{Actions}</th>
                    </tr>
                </thead>
                <tbody>
              {guestUsers.map((data, i) => {
                return (
                  <tr key={data.id}>
                      <th scope="row">{i}</th>
                      <td>
                        <UserThumbnail userID={[data.id]}/>
                      </td>
                      <td><Badge color="success">{Registered}</Badge></td>
                      <td>
                          <Button color="danger" className="btn-xs mr-1 f-none m-t-20" >{Delete}</Button>
                          <Button color="danger" className="btn-xs mr-1 f-none m-t-20" >{BlockUser}</Button>
                          <Button outline color="warning" className="btn-xs mr-1 f-none m-t-20" >{SendRegistrationReminder}</Button>
                      </td>
                  </tr>
                )
              })}
                </tbody>
            </Table>
        </div>
    </Fragment>
  )
}
export default GuestsListTable
